<template>
  <defaultFrame></defaultFrame>
</template>


<script lang="ts">
export default {
  name:'defaultFrameLevel'
}
</script>
<script lang="ts" setup>
import defaultFrame from '../defaultFrame/index.vue';
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {unref} from "vue";
import {MenuModeEnum, MenuTypeEnum} from "@/enums/menuEnum";
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";

const {
  getIsHorizontal,
  getCollapsed,
  getSplit,
} = useMenuSetting();

baseHandler(HandlerEnum.CHANGE_LAYOUT, {
  mode: MenuModeEnum.INLINE,
  type: MenuTypeEnum.MIX_SIDEBAR,
  split: unref(getIsHorizontal) ? false : undefined,
});
</script>

<style type="text/css" lang="less"></style>
